module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Send-cd37da7e9eff8699019a3cd5160305db.svg";